import React from 'react';
import styled from 'styled-components';
import Slider, { Handle } from 'rc-slider';
import classnames from 'classnames';
import Tooltip from '../Tooltip/Tooltip';
import { Box } from '../Box/Box';
import { DISPLAY, POSITION } from '../../utils/constants';
import 'rc-slider/assets/index.css';
import './_range-slider.scss';

const StyledHiddenInput = styled.input`
  display: ${DISPLAY.NONE};
`;

const DEFAULT_SLIDER_INPUT_ID = 'rc-slider-input';

// determines tooltip placement by how close the value is to the min or max
const getDynamicPlacement = ({ min, max, value }) => {
  const range = max - min;
  const val = value - min;
  if (val < range * 0.1) {
    return 'topLeft';
  } else if (val > range * 0.9) {
    return 'topRight';
  } else {
    return 'top';
  }
};

const getCustomHandle = ({
  tipFormatter,
  tipAlwaysVisible,
  tipDynamicPlacement
}) => ({ value, dragging, index, min, max, ...restProps }) => (
  <Tooltip
    overlay={tipFormatter ? tipFormatter(value) : value}
    placement={
      tipDynamicPlacement === true
        ? getDynamicPlacement({ min, max, value })
        : 'top'
    }
    visible={tipAlwaysVisible === true ? tipAlwaysVisible : dragging}
    key={index}
  >
    <Handle value={value} {...restProps} />
  </Tooltip>
);

const RangeSlider = ({
  className,
  id,
  name,
  label,
  tip,
  value,
  tipFormatter,
  tipAlwaysVisible,
  tipDynamicPlacement,
  edgeTicks = false,
  ...otherProps
}) => {
  const inputId = id || DEFAULT_SLIDER_INPUT_ID;
  return (
    <Box position={POSITION.RELATIVE} className={className} width="100%">
      {label && (
        // eslint-disable-next-line jsx-a11y/label-has-for
        <label id={`${inputId}-label`} htmlFor={inputId}>
          {label}
        </label>
      )}
      <Slider
        className={classnames(edgeTicks && 'rc-slider--edge-ticks')}
        included
        value={value}
        handle={
          tip &&
          getCustomHandle({
            tipFormatter,
            tipAlwaysVisible,
            tipDynamicPlacement
          })
        }
        {...otherProps}
      />
      <StyledHiddenInput
        id={inputId}
        type="range"
        value={value}
        name={name}
        readOnly
      />
    </Box>
  );
};

export default RangeSlider;
